import map from "lodash/map";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getFarger } from "../../../actions/fargerActions";
import * as title from "../../../constants/titles";
import Table from "../../Common/Tables/BaseTable";
import FargerModal from "./UpdateModals/FargerModal";

export default function FargerList({ authorizedToCreateAndEdit }) {
  const farger = useSelector((state) => state.farger);
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = title.grunndataFarger;
    dispatch(getFarger());
  }, [dispatch]);

  const headerRow = ["Kode", "Navn", ""];
  return (
    <div className="table-wrapper-horizontal-scroll">
      <Table id="farge-liste" headerRow={headerRow} defaultStyle striped>
        <tbody>
          {map(farger, (farge) => (
            <tr key={`fargerTableBodyTr${farge.id.toString()}`}>
              <td>{farge.kode}</td>
              <td>{farge.navn}</td>
              <td>
                {authorizedToCreateAndEdit && <FargerModal farge={farge} />}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
